import React, { useState, useEffect } from "react";
import "./App.css"
import HowItWorks from "./how-it-works-modal-window/HowItWorks";
import TimeTrackReporterForm from "./time-track-reporter-form/TimeTrackReporterForm";
import { Routes, Route, Navigate, Link, useNavigate } from 'react-router-dom';
import About from "./shared/About";

const App = () => {

  const DefaultPage = () => (
    <div>
      <div id="logo"></div>
      <div>
        <div className="header-container">
          <h1 className="app-container__header">
            Generate Time Spent Report
          </h1>
          <HowItWorks />
        </div>        
        <p className="app-container__header">
          Enter details to generate CSV or XLSX report
        </p>
        <TimeTrackReporterForm />
      </div>
    </div>
  );

  const navigate = useNavigate();
  const AboutPage = () => (
    <>
      <div id="logo" onClick={() => navigate("/")} style={{cursor: 'pointer'}}></div>
      <About />
    </>
  );

  return (
    <Routes>
      <Route path="/" element={<DefaultPage />} />
      <Route path="/about" element={<AboutPage />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
